System.register('ext/ni_assets/Resources/Public/Modules/tracking/init.js', ['./track.js', 'jquery'], function (_export, _context) {
    "use strict";

    var Track, $;
    function init() {

        initPageHiding();
        initGoogleTagManager();
        registerTrackingEvents();

        window.Track = Track;
    }

    _export('init', init);

    function initPageHiding() {
        var head = document.getElementsByTagName('head')[0];
        var s = document.createElement('style');
        s.appendChild(document.createTextNode('.async { opacity: 0 !important }'));
        head.appendChild(s);

        (function (a, s, y, n, c, h, i, d, e) {
            s.className += ' ' + y;
            h.start = 1 * new Date();
            h.end = i = function i() {
                s.className = s.className.replace(RegExp(' ?' + y), '');
            };
            (a[n] = a[n] || []).hide = h;
            setTimeout(function () {
                i();
                h.end = null;
            }, c);
            h.timeout = c;
        })(window, document.documentElement, 'async-hide', 'dataLayer', 4000, { 'GTM-WHBD34M': true });
    }

    function initGoogleTagManager() {
        window.dataLayer = [{
            'pageCategory': 'www',
            'pageUrl': window.location.href,
            'country': Util.getCountry(),
            'lang': Util.getLang(),
            'authentication': Account.getAuthState()
        }];

        (function (w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({
                'gtm.start': new Date().getTime(), event: 'gtm.js'
            });
            var f = d.getElementsByTagName(s)[0],
                j = d.createElement(s),
                dl = l != 'window.dataLayer' ? '&l=' + l : '';
            j.async = true;
            j.src = '//www.googletagmanager.com/gtm.js?id=' + i + dl;
            f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', window.tagManagerProfile);
    }

    /**
     * General Track Events
     */
    function registerTrackingEvents() {

        // unique user hash
        if (Util.getParameter('uuh') != '' && Util.getParameter('uuh') != Util.getCookie('uuh')) {
            Util.setCookie('uuh', Util.getParameter('uuh'), null, 60 * 60 * 24 * 365 * 2);
        }

        // download links
        $(document).on('click', '.ga-event-download', function () {
            var a = document.createElement('a');
            a.href = $(this).attr('href');
            Track.analyticsEvent('Download Button', a.pathname.split('/').pop(), ($(this).attr('title') || $(this).text()).trim(), 1);
        });

        // modal popups
        $(document).on('click', '.btn, .popup', function () {
            if ($(this).data('toggle') == 'modal') {
                Track.analyticsEvent('Modal Open', $(this).attr('href'), $(this).text(), $(this).attr('title'));
            }
        });

        // popover
        $(document).on('click', '.popover-link', function () {
            Track.analyticsEvent('Popover Open', $(this).attr('href'), $(this).text(), $(this).attr('title'));
        });

        // media
        $(document).on('click', '.media-item', function () {
            var link = $(this).find('a');
            var playerIcon = link.children('span.player-icon');
            // don't track pause triggers
            if (playerIcon.length && playerIcon.hasClass('nisp-paused')) {
                // we check for "nisp-paused" because the element's class has already been changed by the time we reach
                // this code
            } else {
                Track.analyticsEvent('Media Play', link.attr('title') + ' - (ID: ' + link.data('content') + ')', link.data('type'), link.attr('href'));
            }
        });

        $(document).on('click', '.finder-product-media > a.btn-media', function () {
            Track.analyticsEvent('Media Play', $(this).attr('title') + ' - (ID: ' + $(this).data('content') + ')', $(this).data('type'), $(this).attr('href'));
        });

        // external links
        $(document).on('click', '.external-link', function () {
            Track.trackOutboundLink(this, 'Outbound Links', $(this).attr('href'));
            return false;
        });

        $(document).on('click', '.demodownload-wrong-email', function () {
            Track.analyticsEvent('Demo Download Wrong E-Mail Click', $(this).attr('href'), $(this).text(), 1);
        });

        // Track Upgrade notifications / clicks
        Account.getUserData().then(function (data) {
            if (!data || !data.loggedIn) return;

            var newUpgrades = Util.arrayDiff(data.upgrades || [], data.shown_upgrades || []);

            if (newUpgrades.length) {
                Track.analyticsEvent('My Offers', 'notification', newUpgrades.length, newUpgrades);
            }

            $(document).on('click', '.account-snippet-link:has(.upgrades-count)', function (e) {
                Track.analyticsEvent('My Offers', 'menu_click', $(this).text(), newUpgrades);
            });
        });
    }
    return {
        setters: [function (_trackJs) {
            Track = _trackJs;
        }, function (_jquery) {
            $ = _jquery.default;
        }],
        execute: function () {}
    };
});